/**
 * Backend team ids whose CDN logo (static.kikkz.de/.../team/{id}.png) is missing
 * in dev/test data (HTTP 403 errors) and are served from local assets instead:
 * `/assets/img/teams/{id}.png`.
 *
 * See `prediction-game.mapper.ts` line ~55 for where this fallback is applied.
 *
 * Note: there is intentionally NO `isDevMode()` gate on this, because the "testing"
 * environment (`environment.testing.ts`, which has `production: true`) has the exact
 * same backend data gaps, and serving the local fallback PNG in production is harmless
 * since the asset file exists in both apps.
 */
export const DEV_LOCAL_TEAM_LOGO_IDS: readonly string[] = [
  '156',
  '157',
  '161',
  '169',
  '171',
  '172',
  '1772',
  '1902',
  '2891',
  '387',
  '683',
] as const;
